/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Hero_CtaInputs */

const en_platform_hero_cta = /** @type {(inputs: Platform_Hero_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start free`)
};

const pl_platform_hero_cta = /** @type {(inputs: Platform_Hero_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zacznij bezpłatnie`)
};

/**
* | output |
* | --- |
* | "Start free" |
*
* @param {Platform_Hero_CtaInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_hero_cta = /** @type {((inputs?: Platform_Hero_CtaInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Hero_CtaInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_hero_cta(inputs)
	return en_platform_hero_cta(inputs)
});